import requestFirebase from '@/config/firebaseConfig';
import { Recomendacao, ConteudoRecomendacao } from './types/recomendacao';
import { APIRequestFilter } from './types';
import requisicaoSegura from '@/auth/requisicaoSegura';
import { APIRecuperarConteudos, TituloRetornoBusca } from './types/titulo';
import { Ficha } from '@/types/ficha';
import { Noticia } from '@/types/noticia';
import { Critica } from '@/types/critica';
import { PropsRecomendacaoPublicacao } from '@/components/molecules/RecomendacaoPublicacao';

export async function listarConteudosEmAltaStreaming(): Promise<
  ConteudoRecomendacao[]
> {
  const emAltaStreamingListagem = await requestFirebase<Recomendacao[]>({
    colecao: 'categoria',
    filtros: [
      [
        'categoriaID',
        '==',
        process.env.NEXT_PUBLIC_CATEGORIA_EM_ALTA_STREAMING_ID!,
      ],
      ['lingua', '==', 'padrao'],
      ['paisID', '==', '55'],
    ],
  });

  const conteudosCategoriaEmAltaStreaming = emAltaStreamingListagem[0];

  const conteudosCategoriaEmAltaStreamingOrdenados =
    conteudosCategoriaEmAltaStreaming.conteudos.sort(
      (a: ConteudoRecomendacao, b: ConteudoRecomendacao) => {
        return a.ordem - b.ordem;
      },
    );

  return conteudosCategoriaEmAltaStreamingOrdenados;
}

export async function listarFilmesEmCartaz(): Promise<ConteudoRecomendacao[]> {
  const listagemFilmesEmCartaz = await requestFirebase<Recomendacao[]>({
    colecao: 'categoriaCinema',
    filtros: [
      ['ativo', '==', true],
      ['lingua', '==', 'padrao'],
      ['paisID', '==', '55'],
    ],
  });

  const conteudosCategoriaCinemaFilmesEmCartaz = listagemFilmesEmCartaz[1];

  const conteudosCategoriaCinemaFilmesEmCartazOrdenados =
    conteudosCategoriaCinemaFilmesEmCartaz.conteudos.sort(
      (a: ConteudoRecomendacao, b: ConteudoRecomendacao) => {
        return a.ordem - b.ordem;
      },
    );

  return conteudosCategoriaCinemaFilmesEmCartazOrdenados;
}

export async function listarSeriesMaisAvaliadasSemana(): Promise<
  ConteudoRecomendacao[]
> {
  const seriesMaisAvaliadasSemanaListagem = await requestFirebase<
    Recomendacao[]
  >({
    colecao: 'categoria',
    filtros: [
      [
        'categoriaID',
        '==',
        process.env.NEXT_PUBLIC_CATEGORIA_SERIES_MAIS_AVALIADAS_SEMANA_ID!,
      ],
      ['lingua', '==', 'padrao'],
      ['paisID', '==', '55'],
    ],
  });

  const conteudosCategoriaSeriesMaisAvaliadasSemana =
    seriesMaisAvaliadasSemanaListagem[0];

  const conteudosCategoriaSeriesMaisAvaliadasSemanaOrdenados =
    conteudosCategoriaSeriesMaisAvaliadasSemana.conteudos.sort(
      (a: ConteudoRecomendacao, b: ConteudoRecomendacao) => {
        return a.ordem - b.ordem;
      },
    );

  return conteudosCategoriaSeriesMaisAvaliadasSemanaOrdenados;
}

export async function listarFilmesMaisAvaliadosSemana(): Promise<
  ConteudoRecomendacao[]
> {
  const filmesMaisAvaliadosSemanaListagem = await requestFirebase<
    Recomendacao[]
  >({
    colecao: 'categoria',
    filtros: [
      [
        'categoriaID',
        '==',
        process.env.NEXT_PUBLIC_CATEGORIA_FILMES_MAIS_AVALIADOS_SEMANA_ID!,
      ],
      ['lingua', '==', 'padrao'],
      ['paisID', '==', '55'],
    ],
  });

  const conteudosCategoriaFilmesMaisAvaliadasSemana =
    filmesMaisAvaliadosSemanaListagem[0];

  const conteudosCategoriaFilmesMaisAvaliadasSemanaOrdenados =
    conteudosCategoriaFilmesMaisAvaliadasSemana.conteudos.sort(
      (a: ConteudoRecomendacao, b: ConteudoRecomendacao) => {
        return a.ordem - b.ordem;
      },
    );

  return conteudosCategoriaFilmesMaisAvaliadasSemanaOrdenados;
}

export async function listarRecomendacoes(): Promise<Recomendacao[]> {
  const retornoListagemCategoriasRecomendacoes = await requestFirebase<
    Recomendacao[]
  >({
    colecao: 'categoria',
    filtros: [
      ['ativo', '==', true],
      ['mostrarHomeInterna', '==', true],
      ['lingua', '==', 'padrao'],
      ['paisID', '==', '55'],
    ],
    ordenacao: ['ordem', 'asc'],
    limit: 2,
  });

  retornoListagemCategoriasRecomendacoes.forEach((lista: Recomendacao) => {
    lista.conteudos.sort((a: ConteudoRecomendacao, b: ConteudoRecomendacao) => {
      return a.ordem - b.ordem;
    });
  });

  return retornoListagemCategoriasRecomendacoes;
}

type TituloComCursor = TituloRetornoBusca & { codigo: number };

export async function recuperarConteudos({
  paginacao = 18,
  pagina = 1,
  filtroBusca = '',
  ordenacaoCampo = 'codigo',
  ordenacaoOrdem = 'desc',
  ultimoItem = undefined,
}: APIRequestFilter): Promise<APIRecuperarConteudos> {
  if (filtroBusca && filtroBusca.trim().length > 0) {
    const filtros = '';

    const responseFilmesBusca: APIRecuperarConteudos = await requisicaoSegura({
      endpoint: '/Titulo/Buscar',
      dataForm: {
        pagina,
        paginacao: paginacao - 8,
        termo: filtroBusca,
        ordenacaoCampo,
        ordenacaoOrdem,
        filtros,
      },
    });

    return responseFilmesBusca;
  } else {
    try {
      const agora = new Date();

      const hojeISO = agora.toISOString();

      const responseFirebase = await requestFirebase<Ficha[]>({
        colecao: 'titulo',
        filtros: [
          ['ativo', '==', true],
          ['lingua', '==', 'padrao'],
          ['dataLancamentoObj', '!=', null],
          ['dataLancamentoObj', '<=', `timestamp(${hojeISO})`],
        ],
        ordenacao: [ordenacaoCampo, ordenacaoOrdem],
        limit: paginacao,
        startAfter: ultimoItem,
      });

      const filmesComCursor = responseFirebase.map(
        (ficha: Ficha): TituloComCursor => ({
          indicadoOscar: ficha.indicadoOscar ?? false,
          vencedorOscar: ficha.vencedorOscar ?? false,
          tituloID: ficha.tituloID,
          slug: ficha.slug,
          titulo: ficha.titulo,
          dataLancamento: ficha.dataLancamento,
          posterArquivo: ficha.posterArquivo,
          sinopse: ficha.sinopse,
          plataformas:
            ficha.plataformas?.map((item) => ({
              link: item.link ?? '',
              plataformaStreaming: {
                plataformaStreamingID:
                  item.plataformaStreaming.plataformaStreamingID,
                nome: item.plataformaStreaming.nome,
                url: '',
                urlx1: item.plataformaStreaming.logoArquivo?.urlx1 ?? '',
                urlx2: '',
                urlx3: '',
              },
              tituloPlataformaID: item.tituloPlataformaID,
              plataformaStreamingID: item.plataformaStreamingID,
            })) ?? [],
          favorito: false,
          verDepois: false,
          codigo: ficha.codigo ?? 0,
        }),
      );

      const total = filmesComCursor.length;
      const indiceInicial = total > 0 ? 1 : 0;
      const indiceFinal = total;
      const ultimaPagina = total < paginacao ? pagina : pagina + 1;

      return {
        dados: {
          lista: filmesComCursor.map(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            ({ codigo, ...filme }) => filme,
          ),
          pagina,
          indiceInicial,
          indiceFinal,
          ultimaPagina,
          total,
        },
        ultimoCursor: filmesComCursor[filmesComCursor.length - 1].codigo,
      };
    } catch (error) {
      console.error('Erro ao buscar no Firebase:', error);
      throw error;
    }
  }
}

export async function recuperarConteudoRecomendacaoEspecifica({
  categoriaID,
}: {
  categoriaID: string;
}): Promise<ConteudoRecomendacao[]> {
  const retornoCategoriaEspecifica = await requestFirebase<Recomendacao[]>({
    colecao: 'categoria',
    filtros: [
      ['categoriaID', '==', categoriaID],
      ['lingua', '==', 'padrao'],
      ['paisID', '==', '55'],
    ],
  });

  if (
    !retornoCategoriaEspecifica.length ||
    !retornoCategoriaEspecifica[0]?.conteudos.length
  ) {
    return [];
  }

  return retornoCategoriaEspecifica[0].conteudos.sort(
    (a: ConteudoRecomendacao, b: ConteudoRecomendacao) => {
      return a.ordem - b.ordem;
    },
  );
}

export async function recuperarNoticiaPorSlug(
  noticiaSlug: string,
): Promise<Noticia | null> {
  const noticia = await requestFirebase<Noticia[]>({
    colecao: 'noticia',
    filtros: [
      ['slug', '==', noticiaSlug],
      ['lingua', '==', 'padrao'],
      ['externa', '==', false],
    ],
    limit: 1,
  });

  if (!noticia || !noticia?.[0]) return null;

  return noticia?.[0];
}

export async function recuperarCriticaPorSlug(
  criticaSlug: string,
): Promise<Critica | null> {
  const critica = await requestFirebase<Critica[]>({
    colecao: 'noticia',
    filtros: [
      ['classificacaoNoticiaID', '==', '64cf06b5-4085-eb11-aaaa-023cdcff6c2b'],
      ['ativo', '==', true],
      ['slug', '==', criticaSlug],
      ['lingua', '==', 'padrao'],
      ['externa', '==', false],
    ],
    limit: 1,
  });

  if (!critica || !critica?.[0]) return null;

  return critica?.[0];
}

export async function recuperarNoticiasRelacionadas({
  noticiaSlug,
  tagsNoticia,
}: {
  noticiaSlug: string;
  tagsNoticia: string[];
}): Promise<PropsRecomendacaoPublicacao[] | []> {
  const noticiasRecomendadas = await requestFirebase<Noticia[]>({
    colecao: 'noticia',
    filtros: [
      ['ativo', '==', true],
      ['slug', '!=', noticiaSlug],
      ['lingua', '==', 'padrao'],
      ['tags', 'array-contains-any', tagsNoticia],
      ['externa', '==', false],
    ],
    limit: 4,
    ordenacao: ['dataNoticiaObj', 'desc'],
  });

  if (!noticiasRecomendadas.length) return [];

  const noticiasRecomendadasFormatadas: PropsRecomendacaoPublicacao[] =
    noticiasRecomendadas.map((noticia) => {
      const { urlx1, urlx2, urlx3 } = noticia.imagemArquivo;
      return {
        imagem: urlx3 || urlx2 || urlx1,
        titulo: noticia.titulo,
        subtitulo: noticia.subtitulo,
        autor: noticia.publicadoPor,
        imagemAutor: noticia?.authorImage,
        rotulo: noticia.tema?.nome,
        link:
          noticia.classificacaoNoticiaID !==
          '64cf06b5-4085-eb11-aaaa-023cdcff6c2b'
            ? `/noticias/${noticia.slug}`
            : `/criticas/${noticia.slug}`,
        data: noticia.dataNoticia,
        duracao: noticia.tempoDeLeitura.toString(),
      };
    });

  return noticiasRecomendadasFormatadas;
}

export async function recuperarCriticasRecomendadas({
  criticaSlug,
  tagsCritica,
}: {
  criticaSlug: string;
  tagsCritica: string[];
}): Promise<PropsRecomendacaoPublicacao[] | []> {
  const criticaRecomendadas = await requestFirebase<Critica[]>({
    colecao: 'noticia',
    filtros: [
      ['classificacaoNoticiaID', '==', '64cf06b5-4085-eb11-aaaa-023cdcff6c2b'],
      ['ativo', '==', true],
      ['slug', '!=', criticaSlug],
      ['lingua', '==', 'padrao'],
      ['externa', '==', false],
      ['tags', 'array-contains-any', tagsCritica],
    ],
    limit: 4,
    ordenacao: ['dataNoticiaObj', 'desc'],
  });

  if (!criticaRecomendadas.length) return [];

  const criticasRecomendadasFormatadas: PropsRecomendacaoPublicacao[] =
    criticaRecomendadas.map((critica) => {
      const { urlx1, urlx2, urlx3 } = critica.imagemArquivo;
      return {
        imagem: urlx3 || urlx2 || urlx1,
        titulo: critica.titulo,
        subtitulo: critica.subtitulo,
        autor: critica.publicadoPor,
        imagemAutor: critica?.authorImage,
        rotulo: critica.tema?.nome,
        link: `/criticas/${critica.slug}`,
        data: critica.dataNoticia,
        duracao: critica.tempoDeLeitura.toString(),
      };
    });

  return criticasRecomendadasFormatadas;
}

export async function listarRecomendacoesParceiros(): Promise<Recomendacao[]> {
  const categoriasParceirosEnv = process.env.NEXT_PUBLIC_CATEGORIAS_PARCEIROS!;

  const idsListasParceiros =
    categoriasParceirosEnv?.split(',').map((id) => id.trim()) ?? [];

  const isArrayValido =
    Array.isArray(idsListasParceiros) &&
    idsListasParceiros.length > 0 &&
    idsListasParceiros.every(
      (id) => id !== null && id !== undefined && id !== '',
    );

  if (!isArrayValido) {
    throw new Error('Não foi possível recuperar as listas do parceiros');
  }

  const retornoListagemCategoriasParceiros = await requestFirebase<
    Recomendacao[]
  >({
    colecao: 'categoria',
    filtros: [
      ['ativo', '==', true],
      ['categoriaID', 'in', idsListasParceiros],
    ],
    ordenacao: ['ordem', 'asc'],
  });

  retornoListagemCategoriasParceiros.forEach((lista: Recomendacao) => {
    lista.conteudos.sort((a: ConteudoRecomendacao, b: ConteudoRecomendacao) => {
      return a.ordem - b.ordem;
    });
  });

  return retornoListagemCategoriasParceiros;
}
